package com.exura.util

import kotlinx.datetime.LocalDateTime

internal fun formatLocalDate(date: LocalDateTime, isWithHours: Boolean = false) = formatLocalDate(date.toString(), isWithHours = isWithHours)

internal fun formatLocalDate(date: String, isWithHours: Boolean = false) = date
    .dropLast(if(isWithHours) 7 else 13)
    .replace("T", " ")
